import { render } from "./about.html?vue&type=template&id=19d929ca&external"
import script from "./about.js?vue&type=script&lang=js&external"
export * from "./about.js?vue&type=script&lang=js&external"

import "./about.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__